import { createTheme } from '@material-ui/core/styles'
import { theme as baseTheme } from '@chilecompra/react-kit/styles'

const theme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    custom: {
      charcoal: '#4A4A4A',
      dimGray: '#707070',
      dustyGray: '#979797',
      heather: '#BFC5D226',
      ghostBlack: '#00000029',
      ghostWhite: '#FFFFFF0F',
      mineShaft: '#3A3A3A'
    }
  }
})

export default theme
